import type { Connection } from '#/domain/connection/Connection'
import type { ConnectionRepository } from '#/domain/connection/ConnectionRepository'

export class GetConnectionListUseCase {
  constructor(private readonly repository: ConnectionRepository) {}

  async execute(): Promise<Connection[]> {
    return this.repository.findAll()
  }
}
